import { Button, Group, Stack, Text, TextInput } from '@mantine/core'
import { useForm } from '@mantine/form'
import { formatPhone } from '@/utils'
import { isValidFax } from './referralTypes'

type Props = {
  recipient: string
  /** A found fax to confirm; the field starts empty when there is none. */
  initialFax?: string
  /** Where `initialFax` came from, shown under the field. */
  sourceLabel?: string
  onSave: (fax: string) => void
  onCancel: () => void
}

// Asked for whenever a provider is added to Frequently used: a found fax is shown for the
// clinician to confirm, never saved unseen.
export const AddFaxForm = ({ recipient, initialFax, sourceLabel, onSave, onCancel }: Props) => {
  const form = useForm({
    initialValues: { fax: initialFax ?? '' },
    validate: { fax: (v) => (isValidFax(v) ? null : 'Enter a 10-digit US fax number') },
  })

  return (
    <form onSubmit={form.onSubmit((v) => onSave(formatPhone(v.fax.trim())))}>
      <Stack gap="sm">
        <Text size="sm" c="dimmed">
          {initialFax
            ? `Confirm the fax for ${recipient}.`
            : `No fax is on record for ${recipient}.`}{' '}
          Frequently used keeps the number referrals are sent to.
        </Text>
        <Stack gap={4}>
          <TextInput label="Fax number" data-autofocus {...form.getInputProps('fax')} />
          {initialFax && sourceLabel && (
            <Text size="xs" c="dimmed">
              From {sourceLabel} — confirm before adding
            </Text>
          )}
        </Stack>
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" color="teal">
            Add
          </Button>
        </Group>
      </Stack>
    </form>
  )
}
